import { has, omit } from 'lodash';
import objectDeepCopy from 'utils/object-deep-copy';

export default function ErrorsBag(errors)
{
    this.errors = errors || {};

    this.capitalizeFirstLetter = function (string)
    {
        return string.charAt(0).toUpperCase() + string.slice(1);
    };

    this.deleteError = function (key) // eslint-disable-line func-names
    {
        if (has(this.errors, key))
        {
            delete this.errors[key];
        }
    };

    this.getReadableError = function (key, _errors)
    {
        const formattedErrors = [];

        for (let i = 0; i < _errors.length; i++)
        {
            const _error = _errors[i];

            try
            {
                const keyParts = key.split('.');
                const field = keyParts.pop();
                const keyPosition = _error.toLowerCase().indexOf(field.replace(/([A-Z])/g, ' $1').toLowerCase());

                if (keyPosition !== -1)
                {
                    formattedErrors.push(this.capitalizeFirstLetter(_error.substring(keyPosition)));
                }
            }
            catch (error)
            {
                formattedErrors.push(_error);
            }
        }

        return formattedErrors;
    };

    this.omit = function (fields) // eslint-disable-line func-names
    {
        return new ErrorsBag(omit(this.errors, fields));
    };

    this.flatten = function () // eslint-disable-line func-names
    {
        if (typeof this.errors === 'undefined')
        {
            return {};
        }

        const tmpErrors = objectDeepCopy(this.errors);

        Object.keys(tmpErrors).forEach((key) =>
        {
            tmpErrors[key] = this.getReadableError(key, tmpErrors[key]).join('<br/>');
        });

        return tmpErrors;
    };

    this.toArray = function () // eslint-disable-line func-names
    {
        return Object.values(this.flatten());
    };
}
